import { render, staticRenderFns } from "./PromotionsEdit.vue?vue&type=template&id=4ad47834&"
import script from "./PromotionsEdit.vue?vue&type=script&lang=js&"
export * from "./PromotionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports